// extracted by mini-css-extract-plugin
module.exports = {"location":"navigation-location_location__NA5iX","heading":"navigation-location_heading__PyhRr","link":"navigation-location_link__yr6V2"};